<template>
  <div class="flex flex-col layout-footer">
    <div class="flex justify-between flex-1 footer-info">
      <div class="text-white" v-for="(item, index) in list" :key="'botttom' + index">
        <p class="mb-4 text-font-18">{{ item.titleZh }}</p>
        <ul class="list-none text-font-14" style="color: #7b7b7c">
          <li @click="gotoLink(sub)" class="cursor-pointer" v-for="(sub, subIndex) in item.children"
            :key="'bottom' + index + 'sub' + subIndex">
            {{ sub.titleZh }}
          </li>
        </ul>
      </div>
      <div class="text-white">
        <p class="mb-4 text-font-18">联系我们</p>
        <div class="mb-2 text-font-14">
          <p>联系电话：</p>
          <p>13916027777</p>
        </div>
        <div class="text-font-14">
          <p>公司地址：</p>
          <p>中国上海普陀区真北路 2167 号鸿海大厦 17 层至 22 层</p>
        </div>
      </div>
      <div class="text-white">
        <img src="@/assets/images/home/ewm.png" alt="" width="85" height="85" class="mb-2" />
        <p>关注维迈公众号<br />获取最新行业资讯</p>
      </div>
    </div>
    <div class="w-full py-2 text-center text-white text-font-12" style="background-color: #303132; color: lightgrey">
      @ 2020 V-CAN All Right Reservered 维迈科技股份有限公司 版权所有

      <a href="https://beian.miit.gov.cn" target="_blank">
        沪 ICP 备 16032530 号 -1
      </a>

      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702006878"
        style="margin-left: 20px; display: inline-block">
        <img src="@/assets/images/home/gongan.png" style="float: left" />
        <a>沪公网安备 31010702006878 号</a>
      </a>
    </div>
  </div>
</template>

<script>
import { getCategory } from '@/api'

export default {
  data() {
    return {
      list: []
    }
  },
  async created() {
    let oneLevel = await this.getList(null, 2)
    // console.log('====oneLevel====')
    // console.log(oneLevel)
    let promises = oneLevel.map(c => this.getList(c.id))
    let twoLevels = await Promise.all(promises)
    let list = []
    oneLevel.forEach((item, index) => {
      list.push({
        ...item,
        children: twoLevels[index]
      })
    })
    this.list = list
  },
  methods: {
    getList(id, type) {
      return getCategory(id, type).then(ret => {
        // console.log('====ret====')
        // console.log(ret)
        let result = []
        if (ret.result) {
          result = ret.result.map(c => {
            return {
              id: c.id,
              titleZh: c.title.zh,
              href: c.link.herf
            }
          })
        } else {
          result = []
        }
        return result
      })
    },
    gotoLink(sub) {
      window.open(sub.href, '_blank')
    }
  }
}
</script>

<style lang="less">
.layout-footer {
  background-color: #000001;

  .footer-info {
    min-width: 1200px;
    margin: auto;
    padding: 30px 67px;

    .split-line {
      height: 90px;
      width: 0;
      border-left: 1px solid #7b7b7c;
      margin-top: 40px;
    }
  }
}
</style>
